import { connect } from 'react-redux';
import { fetchArticlesInMyCourses } from '../../../../actions';
import ArticleList from './article-list';
import _ from 'lodash';


const mapStateToProps = (state, ownProps) => {
  return {
    articles: _.get(state, 'home.articlesInMyCourses.data.articles', []),
    loading: !!_.get(state, 'loading.FETCH_ARTICLES_IN_MY_COURSES', null),
    forMyCourses: true,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchArticles: () => dispatch(fetchArticlesInMyCourses()),
  };
};

// tslint:disable-next-line:variable-name
const ArticlesListArticlesInMyCourses = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ArticleList);

export default ArticlesListArticlesInMyCourses;
